export const letGoLyrics = [
  { text: "Mm", start: 2.5, end: 3.5 },
  { text: "Mm", start: 3.5, end: 4.5 },
  { text: "Mmmm", start: 4.5, end: 5 },
  { text: "Mm", start: 5, end: 6 },
  { text: "Mm mm mmm", start: 6, end: 10 },
  { text: "Mhm", start: 10, end: 11 },
  { text: "Mm", start: 11, end: 12 },
  { text: "Mmm", start: 12, end: 13 },
  { text: "Hammer to nail", start: 13, end: 14 },
  { text: "I annihilate all of my flaws", start: 14, end: 16.3 },
  { text: "When the morning comes", start: 16.3, end: 17.5 },
  { text: "I won't live in the past", start: 17.5, end: 20 },
  { text: "Now I've loosened my grasp", start: 20, end: 23.3 },
  { text: "Now I'm", start: 23.3, end: 25.5 },
  { text: "Belly up filled with anguish", start: 25.5, end: 28.3 },
  { text: "Ravenously craving for when change comes", start: 28.3, end: 31 },
  { text: "So I swallow", start: 31, end: 32.42 },
  { text: "Swallow", start: 32.42, end: 34 },
  { text: "All my sorrows", start: 34, end: 36.5 },
  { text: "Sorrows", start: 36.5, end: 38 },
  { text: "Every time you doubt yourself you throw away your dreams", start: 38, end: 41.45 },
  { text: "You pray for confidence but struggle to be seen", start: 41.45, end: 44 },
  { text: "You won't", start: 44, end: 45.7 },
  { text: "Let go", start: 45.7, end: 48.6 },
  { text: "One moment you cling to all the levels that you've reached", start: 48.6, end: 54.2 },
  { text: "But on the ground you question all that it means", start: 54.2, end: 57 },
  { text: "You won't", start: 57, end: 58.5 },
  { text: "Let go", start: 58.5, end: 61.4 },
  { text: "Let go", start: 61.4, end: 63.12 },
  { text: "Go", start: 63.12, end: 64 },
  { text: "You treat your passion like a curfew", start: 64, end: 67.84 },
  { text: "Why limit what you have", start: 67.84, end: 70.84 },
  { text: "What you have have have have)", start: 70.84, end: 76.2 },
  { text: "Peddles to pavement when light hits you", start: 76.2, end: 81.1 },
  { text: "So learn how to adapt", start: 81.1, end: 83.8 },
  { text: "Not to react", start: 83.8, end: 87.8 },
  { text: "Try not to give weight to", start: 87.8, end: 90 },
  { text: "What they try to make you", start: 90, end: 91 },
  { text: "Don't let them enslave you", start: 91, end: 93 },
  { text: "Stop giving your day to", start: 93, end: 95 },
  { text: "The things you escape to", start: 95, end: 97 },
  { text: "Or persuade you", start: 97, end: 98.5 },
  { text: "To stay in a place where you keep contemplating", start: 98.5, end: 103.1 },
  { text: "All that you could be", start: 103.1, end: 106.3 },
  { text: "I know", start: 106.3, end: 108.5 },
  { text: "You doubt yourself for the thrill", start: 108.5, end: 111 },
  { text: "Long as you doubt", start: 111, end: 112.7 },
  { text: "You'll never have to live up to the appeal", start: 112.7, end: 115 },
  { text: "Every time you doubt yourself you throw away your dreams", start: 115, end: 118 },
  { text: "You pray for confidence but struggle to be seen", start: 118, end: 120.9 },
  { text: "You won't", start: 120.9, end: 122.5 },
  { text: "Let go", start: 122.5, end: 125 },
  { text: "You won't let goooo", start: 125, end: 127.8 },
  { text: "One moment you cling to all the levels that you've reached", start: 127.8, end: 131 },
  { text: "But on the ground you question all that it means", start: 131, end: 133.9 },
  { text: "You won't", start: 133.9, end: 135.4 },
  { text: "Let go", start: 135.4, end: 137 },
  { text: "Let go", start: 137, end: 138.5 },
  { text: "Let go", start: 138.5, end: 140 },
  { text: "Let go", start: 140, end: 141.5 },
  { text: "You treat your passion like a curfew", start: 142, end: 145 },
  { text: "Why limit what you have", start: 145, end: 147.5 },
  { text: "What you have have have have", start: 147.5, end: 154 },
  { text: "Pedals to pavement when light hits you", start: 154, end: 157.77 },
  { text: "So learn how to adapt", start: 157.77, end: 160.77 },
  { text: "Not to react", start: 160.77, end: 164.4 },
  { text: "Perceivement is dangerous", start: 164.4, end: 169 },
  { text: "Trust your own opinions", start: 169, end: 172.6 },
  { text: "Failure is certain", start: 172.6, end: 175.7 },
  { text: "It don't change your purpose", start: 175.7, end: 178.9 },
  { text: "Don't place your self worth in", start: 178.9, end: 182.1 },
  { text: "Hands not fit", start: 182.1, end: 183.5 },
  { text: "To nurture it", start: 183.5, end: 185.57 },
  { text: "Don't give up on your dreams", start: 185.57, end: 191.7 },
  { text: "Every time you doubt yourself you throw away your dreams", start: 191.7, end: 194.9 },
  { text: "You pray for confidence but struggle to be seen", start: 194.9, end: 198 },
  { text: "You won't", start: 198, end: 199.6 },
  { text: "Let go", start: 199.6, end: 202.1 },
  { text: "One moment you cling to all the levels that you've reached", start: 202.1, end: 207.8 },
  { text: "But on the ground you question all that it means", start: 207.8, end: 210.88 },
  { text: "You won't", start: 210.88, end: 212.2 },
  { text: "Let go", start: 212.2, end: 215.19 },
  { text: "Let go", start: 215.19, end: 217 },
  { text: "Go", start: 217, end: 218.3 },
] as const satisfies ReadonlyArray<{ readonly text: string, readonly start?: number, readonly end?: number }>;
